import { render, staticRenderFns } from "./config-uracion.vue?vue&type=template&id=7f01fb3b"
import script from "./config-uracion.vue?vue&type=script&lang=js"
export * from "./config-uracion.vue?vue&type=script&lang=js"
import style0 from "./config-uracion.vue?vue&type=style&index=0&id=7f01fb3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports